/**
* GENERATED BY KRPC GEN - LESS MODIFY BY HAND
* redpackactivity-service.ts  2026-08-26T09:15:21+08:00
*/
import type { R, RpcService, MethodConfig as M } from 'krpc-base';

import type { RpRecord } from './wy-dto';

const _ = 'RedPackActivity/';

export class RedPackActivityService {

  constructor(readonly r: RpcService) {}
  // 查询已获取红包用户记录
  redPackRecordList(m?: M): R<Array<RpRecord>>{
    return this.r.async(_ + 'redPackRecordList', undefined, m);
  }
}
